<template>
    <div class="container-fluid">
        <div class="row pt-3">
            <div class="col-md-12 designRowOrga">
                <div class="h3Organization mb-3">
                    <router-link class="back-route h3" ref="backBtn" to="/user-trainings">
                        <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                        Training
                    </router-link>
                </div>
                <div class="">
                    <div v-if="isCompetionEnded && training.is_user_submit !== 1">
                        <button @click.prevent="StartTraining" class="btn-container">
                            Start Training
                        </button>
                    </div>
                    <div class="flexTwoButtons" v-else-if="training.is_user_submit === 1">
                        <button @click.prevent="StartTraining" class="btn-container">
                            Retake Training
                        </button>
                        <button @click.prevent="ViewModelAnswer" class="btn-container">
                            View Model Answer
                        </button>
                    </div>
                    <div v-else>

                    </div>

                </div>
            </div>
        </div>

        <div class="row tabContent">
            <div class="tabContent1  mb-5">
                <div class="">
                    <h3>Start Date</h3>
                    <h5>{{training.start_date}}</h5>
                </div>
                <div class="">
                    <h3>End Date</h3>
                    <h5>{{training.end_date}}</h5>
                </div>
                <div class="">
                    <h3>Start Time</h3>
                    <h5>{{training.start_time}} GMT</h5>
                </div>
                <div class="">
                    <h3>Duration</h3>
                    <h5>{{training.duration}} minutes</h5>
                </div>
                <vue-countdown v-if="(startCountflag && !isCompetionEnded)" @start="onCountdownStart" @end="onCountdownEnd" :time="diffTime"
                               v-slot="{ days, hours, minutes, seconds }">
                    <div class="d-flex gap-3">
                        <div class="daysCss text-center">
                            <h5>{{days >= 10 ? days : '0'+ days}}</h5>
                            <p>Days</p>
                        </div>

                        <div class="columnCss">:</div>

                        <div class="minsCss text-center">
                            <h5>{{hours > 10 ? hours : '0'+ hours}}</h5>
                            <span>Hours</span>
                        </div>

                        <div class="columnCss">:</div>

                        <div class="minsCss text-center">
                            <h5>{{minutes >= 10 ? minutes : '0'+ minutes}}</h5>
                            <span>Minutes</span>
                        </div>

                        <div class="columnCss">:</div>

                        <div class="minsCss text-center">
                            <h5>{{seconds >= 10 ? seconds : '0'+ seconds}}</h5>
                            <span>Seconds</span>
                        </div>

                    </div>
                </vue-countdown>
            </div>

                <div class="allContent px-0">
                    <div class="firstContent">
                        <p class="px-0 cssCheckLight" >Template Description</p>
                        <div class="tabContent2 mb-3">
                            <div class="desc w-100">
                                {{template.description}}
                            </div>
                        </div>

                        <p class="px-0 cssCheckLight" >Template Questions</p>
                        <div class="tabContent3 mb-3">
                            <ul class="ulDesign1">
                                <li v-for="question in questionsTypes" :key="question">
                                    <p style="display: contents">{{question}}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div v-if="template.matrial_status === 1" class="px-0">
                    <p class="px-0 cssCheckLight" >Template Material</p>
                    <div class="d-flex flex-wrap flexDesign">
                        <div class="w-100 tabContent4">
                            <ul class="ulDesign list-group" v-if="template.files.length > 0">
                                <li class="file-container" v-for="fileLink in template.files" :key="fileLink.id">
                                    <img class="file-img-icon" title="View Matrial"
                                         @click="viewHandler($event,fileLink.file, fileLink.type, fileLink.fileName)"
                                         :src="getFileIcon(1,fileLink.fileName)" width="50" height="50" alt="">
                                    <br>
                                    <span class="text-center file-name">{{fileLink.fileName}}</span>
                                </li>
                            </ul>
                            <ul v-else>
                                No Files
                            </ul>
                        </div>
                        <div class="w-100 tabContent4">
                            <ul class="ulDesign list-group" v-if="template.videoLinks.length > 0">
                                <li v-for="video in template.videoLinks" :key="video.id">
                                    <iframe style="pointer-events: none;" width="150" height="100"
                                            :src="video.file">
                                    </iframe>
                                    <br>
                                    <div class="text-center">
                                        <button @click="PreviewVideo(video)" class="styleBtnPreview btn">Preview</button>
                                    </div>
                                </li>
                            </ul>
                            <ul v-else>
                                No Video Link
                            </ul>
                        </div>
                    </div>
                </div>
                <div v-else></div>

            </div>
    </div>

    <PreviewVideo :video="videoPlayed" v-if="isShown" @close-modal="isShown = false"/>
</template>

<script>
    import training from "../../../api-services/training";
    import getFileExt from "../../../helpers/getFileExt";
    import VueCountdown from "@chenfengyuan/vue-countdown";
    import moment from "moment";
    import PreviewVideo from "../../components/PreviewVideo";

    export default {
        name:'viewUser-training',
        data(){
            return {
                startCountflag: false,
                isCompetionEnded: false,
                isCompetitionEndedLast:false,
                status:'',
                time: null,
                start: null,
                end: null,
                d: null,
                questionsTypes:[],
                questionsCat:[],
                videoPlayed:null,
                isShown:false,
                training:{
                    start_date: null,
                    end_date: null,
                    start_time: null,
                    end_time: null,
                    duration: null,
                    is_submited:0,
                    is_user_submit:0,
                },
                template:{
                    id:null,
                    matrial_status:null,
                    description:null,
                    questions:[],
                    slides:[],
                    material: [],
                    files: [],
                    videoLinks: []
                },
                data: {
                    questions: [],
                    slides: [],
                },
                diffTime:null
            }
        },
        components: {
            VueCountdown,
            PreviewVideo
        },
        mounted(){
            this.showTraining();
        },
        methods:{
            PreviewVideo(video){
                this.isShown = true;
                this.videoPlayed = video.file;
            },
            getFileIcon(type, fileName) {
                const ext = getFileExt(type, fileName);
                return require(`../../../assets/images/${ext}.png`) ? require(`../../../assets/images/${ext}.png`) :  require(`../../../assets/images/document.png`);

            },
            async viewHandler(e, filePath, fileType = null, fileName = null) {
                // const link = document.createElement("a");
                // link.href = filePath;
                // link.download = `${fileName}`;
                // link.click();

                window.open(`${process.env.VUE_APP_AWS_STREEM_URL}/materials/${filePath}`)
            },
            async showTraining(){
                try{
                    const id = this.$route.params.id;
                    const response = await training.show(id);
                    console.log(response.data.data);

                    this.training.start_date = moment(response.data.data.start_date).format('D-MMM-YYYY');;
                    this.training.end_date = moment(response.data.data.end_date).format('D-MMM-YYYY');;
                    this.training.start_time = response.data.data.start_time.slice(0,5);
                    this.training.end_time = response.data.data.end_time.slice(0,5);
                    this.training.duration = response.data.data.duration;
                    this.training.is_submited = response.data.data.is_submited;
                    this.training.is_user_submit = response.data.data.is_user_submit;
                    this.template.id = response.data.data.template.id;
                    this.template.matrial_status = response.data.data.template.matrial_status;
                    this.template.description = response.data.data.template.description;
                    this.template.questions = response.data.data.template.questions;
                    this.template.slides = response.data.data.template.slides;
                    this.data.questions = response.data.data.template.questions;
                    this.data.slides = response.data.data.template.slides;
                    this.template.material = response.data.data.template.attachments;

                    this.template.files = this.template.material.filter(function (value) {
                        return value.type === "1";
                    });

                    this.template.videoLinks = this.template.material.filter(function (value) {
                        return value.type === "2";
                    });

                    console.log("q-types => ",  this.template.questions)
                    for(let i = 0 ; i < this.template.questions.length ; i++){
                        if (this.questionsTypes.indexOf(this.template.questions[i].title) === -1) {
                            this.questionsTypes.push(this.template.questions[i].title);
                        }
                    }

                    for(let i = 0 ; i < this.template.slides.length ; i++){
                        this.questionsTypes.push(this.template.slides[i].title);
                    }

                    this.questionsCat = this.questionsTypes.filter((c, index) => {
                        return this.questionsTypes.indexOf(c) === index;
                    });

                    var today = new Date();
                    var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
                    var time = '';

                    if(today.getHours() < 10){
                        time = '0'+today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                    }else{
                        time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                    }

                    if(this.training.end_time <= time){
                        this.isCompetitionEndedLast = true;
                    }

                    if(this.training.end_date === moment(date).format('YYYY-MM-DD') && this.training.end_time === time){
                        this.status= 'Ended';
                    }


                    this.time = moment(this.training.start_date).format('YYYY-MM-DD') + 'T' + this.training.start_time;
                    let now = moment.utc().format('YYYY-MM-DDTHH:mm:ss');
                    console.log('tt => ', now)


                    this.diffTime = moment.duration(moment(this.time).diff(moment(now))).as('minutes') * 60000;
                    console.log('tt => ', this.diffTime)
                    this.start = moment(this.training.start_date).format('D MMM YYYY') + 'T' + this.training.start_time;
                    this.end = moment(this.training.end_date).format('D MMM YYYY') + 'T' + this.training.end_time;

                    if(this.training.duration === null){
                        let startTime = moment(this.training.start_time, "HH:mm:ss a");
                        let endTime = moment(this.training.end_time, "HH:mm:ss a");
                        let duration  = moment.duration(endTime.diff(startTime));
                        let hours = parseInt(duration.asHours()) * 60;
                        let minutes = parseInt(duration.asMinutes()) % 60;

                        this.d = (hours+minutes);
                    }

                    console.log(this.time);
                    console.log(this.start);
                    console.log(this.end);
                    console.log(this.d);
                    this.startCountflag = true;

                }catch (e) {
                    console.log(e);
                }
            },
            StartTraining(){
                this.$router.push({path: `/trainings/${this.$route.params.id}/start`});
            },
            ViewModelAnswer(){
                this.$router.push({path: `/view/model/${this.template.id}/answers`});
            },
            onCountdownStart(){
                console.log('start')
            },
            async onCountdownEnd() {
                console.log('end')
                this.isCompetionEnded = true;
                this.status = 'Started';
            }
        }
    }
</script>

<style scoped>
    .cssCheckLight{
        color: var(--main-color);
    }
    .styleBtnPreview{
        background-color: var(--btn-bg-color);
        color: var(--btn-text-color);
    }
    .styleBtnPreview:hover{
        background-color: var(--btn-bg-color);
        color: var(--btn-text-color);
    }
    .flexTwoButtons{
        display: flex;
        flex-wrap: wrap;
        gap:20px;
    }
    .minsCss h5 {
        font-size: 29px;
    }

    .minsCss {
        display: block;
        background-color: #fff;
        color: #000;
        padding: 5px;
        width: 75px;
        height: 75px;
        border-radius: 5px;
    }

    .columnCss {
        color: #E95626;
        font-size: 44px;
        font-weight: bold;
    }

    .daysCss h5 {
        font-size: 29px;
    }

    .daysCss {
        display: block;
        background-color: #fff;
        color: #000;
        padding: 5px;
        width: 70px;
        height: 75px;
        border-radius: 5px;
    }
    .file-container{
        width: 100px;
        height: 45%;
        display: flex;
        flex-direction: column;
        align-content: center;
        align-items: center;
        cursor: pointer;
    }
    .file-name {
        text-overflow: ellipsis;
        overflow: hidden;
        width: 130px;
        height: 2.2em;
        align-self: flex-start;
        white-space: nowrap;
    }
    .list-group {
        flex-direction: row;
    }

    .flexDesign {
        gap: 60px;
        padding-right: 0px;
    }

    .tabContent4 {
        display: flex;
        padding: 30px;
        width: 47%;
        background-color: #022F43;
        border: 1px solid #6F8896;
        height: 280px;
        border-radius: 10px;
        overflow: auto;
    }

    .ulDesign1 {
        list-style: none;
        display: flex;
        flex-wrap: wrap;
        gap: 100px;
    }

    .ulDesign {
        list-style: none;
    }

    .ulDesign1 li::before {
        content: "\2022";
        color: #e65c00;
        font-weight: bold;
        font-size: 20px;
        display: inline-block;
        width: 1em;
        margin-left: -1em;
    }

    .ulDesign {
        display: flex;
        flex-wrap: wrap;
        gap: 50px;
    }
    .allContent{
        display: flex;
        justify-content: space-between;
        gap:60px;
    }
    .firstContent{
        width: 200%;
    }
    .secondContent{
        width: 100%;
    }
    .ulDesign1{
        list-style: none;
        display: flex;
        gap: 90px;
    }
    .ulDesign1 li::before {
        content: "\2022";
        color: #e65c00;
        font-weight: bold;
        font-size: 20px;
        display: inline-block;
        width: 1em;
        margin-left: -1em;
    }
    .designRowOrga {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 0px;
        margin-bottom: 20px;
    }

    .btnOrganization button {
        background-color: #E95626;
        color: #fff;
        border: none;
        border-radius: 5px;
        justify-content: end;
        align-items: center;
        align-content: center;
        padding: 10px;
    }
    .tabContent4{
        display: block;
        padding: 30px;
        height: fit-content;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        border-radius: 10px;
    }
    .tabContent3{
        display: flex;
        padding: 30px;
        height: 10vh;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        border-radius: 10px;
    }
    .tabContent2 .desc{
        height: 100px;
        overflow: auto;
    }
    .tabContent2{
        display: flex;
        padding: 30px;
        height: 18vh;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        border-radius: 10px;
    }
    .tabContentCss{
        display: flex;
        gap: 200px;
    }
    .tabContent1{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 30px;
        height: 15vh;
        width: 100%;
        overflow-y: auto;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        border-radius: 10px;
        gap: 50px;
    }

    @media only screen and (max-width: 1300px) and (min-width: 1250px)  {
        .tabContent1{
            height: 22vh;
        }

        .tabContent3{
            height: 13vh;
        }
    }

    @media only screen and (max-width: 1170px) and (min-width: 1024px)  {
        .ulDesign1{
            gap:63px;
        }
        .tabContent3{
            height: 17vh;
        }
    }

    .tabContent{
        display: flex;
        padding: 30px;
        /*height: 80vh;*/
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        border-radius: 20px;
    }
</style>